import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { StaffManagerListItem } from "../../staff.types";
import { requestGetStaffManagers } from "./getStaffManagers.request";

export const useGetStaffManagersList = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<StaffManagerListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["staff", "admin", "all", requestParams],
    queryFn: async () => await requestGetStaffManagers(requestParams),
    onError: toastServerError,
    ...options
  });

  return { staffManagersList: data?.data, meta: data?.meta, ...rest };
};
